export const shouldHydrateDigestDestinations = (digest) => (
  Boolean(digest?.title)
  && (!Array.isArray(digest.destinations) || digest.destinations.length === 0)
);
